export const DesignRefitNotice = (props: { pending?: boolean; onRetry: () => void }) => (
  <span role="status" className="text-xs text-neutral-500 dark:text-neutral-400">
    {props.pending
      ? 'Still updating to its Design.'
      : 'This document couldn\u2019t be fitted to its Design.'}{' '}
    <button
      type="button"
      onClick={props.onRetry}
      className="font-medium text-neutral-700 underline dark:text-neutral-200"
    >
      Retry
    </button>
  </span>
);
